import { SVGProps } from 'react';

const Settings = ({
  props,
  fill = 'currentColor',
  size = '1rem',
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M12.703 4.552c-.179-.736-1.228-.736-1.406 0a2.785 2.785 0 0 1-.273.696 2.73 2.73 0 0 1-3.107 1.287l-1.68.696a2.725 2.725 0 0 1-1.684 4.066l.484 1.573a2.726 2.726 0 0 1 1.199 3.897c-.395.649.348 1.39.995.996a2.726 2.726 0 0 1 4.066 1.684c.179.737 1.227.737 1.406 0a2.733 2.733 0 0 1 .578-1.129 2.724 2.724 0 0 1 3.486-.554c.649.395 1.39-.348.996-.995a2.723 2.723 0 0 1 1.684-4.066c.737-.179.736-1.227 0-1.406a2.725 2.725 0 0 1-1.683-4.064c.395-.649-.348-1.39-.996-.996a2.724 2.724 0 0 1-4.065-1.685Zm7.216 4.801a.724.724 0 0 1-.288-.143l-.012-.01a.724.724 0 0 1-.147-.927c1.485-2.44-1.306-5.23-3.745-3.744a.724.724 0 0 1-1.08-.448c-.674-2.775-4.62-2.775-5.294 0l-1.08.447c-2.44-1.485-5.23 1.306-3.744 3.744a.726.726 0 0 1-.448 1.081c-2.774.673-2.775 4.62 0 5.294a.724.724 0 0 1 .288.143l.012.01a.723.723 0 0 1 .147.927c-1.485 2.439 1.306 5.23 3.744 3.744a.726.726 0 0 1 1.081.448c.673 2.774 4.62 2.775 5.293 0a.727.727 0 0 1 .144-.288l.01-.012a.723.723 0 0 1 .927-.147c2.439 1.485 5.23-1.306 3.744-3.745a.723.723 0 0 1 .448-1.08c2.774-.673 2.774-4.62 0-5.294ZM9.17 9.172a4 4 0 1 1 5.657 5.656A4 4 0 0 1 9.17 9.172Zm1.415 1.414a2 2 0 1 1 2.828 2.828 2 2 0 0 1-2.828-2.828Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Settings;
